document.addEventListener('DOMContentLoaded', function () {
    const accordionToggle = document.querySelectorAll('.accordion-toggle');

    accordionToggle.forEach(toggle => {
        toggle.addEventListener('click', function () {
            const content = toggle.closest('.accordion-item').querySelector('.accordion-content');
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

              accordionToggle.forEach(otherToggle => {
                const otherContent = otherToggle.closest('.accordion-item').querySelector('.accordion-content');
                if (otherToggle !== toggle) {
                    otherContent.classList.add('hidden');
                    otherToggle.setAttribute('aria-expanded', 'false');
                    otherToggle.querySelector('svg').classList.remove('rotate-180');
                }
            });

            if (isExpanded) {
                content.classList.add('hidden');
                toggle.setAttribute('aria-expanded', 'false');
                toggle.querySelector('svg').classList.remove('rotate-180');
            } else {
                content.classList.remove('hidden');
                toggle.setAttribute('aria-expanded', 'true');
                toggle.querySelector('svg').classList.add('rotate-180');
            }
        });
    });
});
